import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import OnlineContent from './OnlineContent'
export default class Online extends Component {
    render() {
        return (
            <>
                <Navbar />
                <Mainmenu />

                <OnlineContent />
                <Footer /> 

            </>


        )
    }
}
